import type { RequestCorrelationContext } from "@octopusdeploy/octopus-server-client";
import type { ReactNode } from "react";
import { useContext, createContext } from "react";
export function useCorrelationContext() {
    return useContext(CorrelationContext);
}
interface CorrelationContextProviderProps {
    children: ReactNode;
    correlationContext: RequestCorrelationContext;
}
export function CorrelationContextProvider({ children, correlationContext }: CorrelationContextProviderProps) {
    return <CorrelationContext.Provider value={correlationContext}>{children}</CorrelationContext.Provider>;
}
const CorrelationContext = createContext<RequestCorrelationContext | null>(null);
